// services/usernameService.js
import supabase from './supabase';

/**
 * Check if username is available
 */
export const checkUsernameAvailability = async (username) => {
  try {
    const { data, error } = await supabase
      .from('usernames')
      .select('username')
      .eq('username', username.toLowerCase())
      .single();
    
    // If error is "not found", username is available
    if (error && error.code === 'PGRST116') {
      return true;
    }
    
    if (error) throw error;
    
    // If data exists, username is taken
    return !data;
  } catch (error) {
    console.error('Error checking username:', error);
    throw error;
  }
};

/**
 * Reserve username for a user
 */
export const reserveUsername = async (username, userId) => {
  try {
    const { error } = await supabase
      .from('usernames')
      .insert({ 
        username: username.toLowerCase(), 
        user_id: userId,
        type: 'user',
        created_at: new Date().toISOString(),
      });
    
    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Error reserving username:', error);
    throw error;
  }
};

/**
 * Update username
 */
export const updateUsername = async (newUsername, userId, oldUsername) => {
  try {
    // Check if new username is available
    const available = await checkUsernameAvailability(newUsername);
    if (!available) {
      throw new Error('Username is already taken');
    }
    
    // Delete old username
    if (oldUsername) {
      await supabase
        .from('usernames')
        .delete()
        .eq('username', oldUsername.toLowerCase());
    }
    
    // Insert new username
    await reserveUsername(newUsername, userId);
    
    return true;
  } catch (error) {
    console.error('Error updating username:', error);
    throw error;
  }
};  